import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as saveAs from 'file-saver';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';

import { NativeDateAdapter } from '@angular/material/core';
import * as XLSX from 'xlsx';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { calculateFiscalYear, formatText, formatYearRanges } from 'src/app/shared/commen-function-file';
import { formatDate } from 'src/app/shared/commen-function-file';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-expense-report',
  templateUrl: './expense-report.component.html',
  styleUrls: ['./expense-report.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ExpenseReportComponent implements OnInit {
  allTeamReimbursement: any = [];
  allTeamMemberReimbursementApprove: any = [];
  currentallTeamMemberReimbursementApprove: any = [];
  allListingEmployeeId: any = [];
  allListingEmployeeIdForTeam: any = [];
  currrentTableDataDetails: any = [];
  fitergetAllFinanceUserDDHrAdmin: any = []
  tableDataDetails: any = [];
  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  buttonColorName: any | null;
  loggedInUserName: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  approveMatrixValueForCondition: any;
  financePerson: any;
  fromYear: any;
  toYear: any;
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Employee'
  isFinanceLoginUser: boolean = false;
  showSetupPopup: boolean = false;
  showImportPopup: boolean = false;

  selectedManagerDashboardId: boolean = false;
  isShowSelectEmployee: boolean = false;
  selectedEmployeeDashboardId: any;

  // Default selected page size
  selectedPageSize: number = 25;
  loggedInUserCompanyName: any;
  currentTableDataDetailsForEmployee: any = [];
  EmployeeSummaryData: any = [];
  arrEmployeeDetiailsBandLocation: any = [];
  arrExpensTypeData: any = [];
  arrLocationForReimursement: any = [];
  arrBandsForReimursement: any = [];
  defaultFromDate: any;
  defaultToDate: any;

  constructor(public sharedService: SharedService,
    private encryptionService: EncryptionService, private activatedroute: ActivatedRoute,
    private httpService: HttpService, private config: Config, public router: Router,
    public dialog: MatDialog, private datePipe: DatePipe,
  ) { }

  ngOnInit() {


    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.financePerson = sessionStorage.getItem('financeAdminId');

    this.financePerson = sessionStorage.getItem('financeAdminId');


    if (this.financePerson && this.financePerson !== 'undefined' && this.financePerson.trim() !== '') {
      this.isFinanceLoginUser = true;
    } else {
      //Not a valid finance person
      this.isFinanceLoginUser = false;
    }

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserCompanyName = sessionStorage.getItem('loggedInUserCompanyName');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }

    this.approveMatrixValueForCondition = this.httpService.passApprovematrixForReport;
    console.log(this.approveMatrixValueForCondition);

    this.getAllUserDD();
    this.getpmsyearlist();

    this.empReimbursementTable();

    // Initialize the paged data
    this.onPageSizeChange();
    this.getEmployee();
    this.getEmployeeDetiailsBandLocation();



    let today = new Date();
    // Set the taskFromDate to 15 days before today's date
    let taskFromDate = new Date(today);
    taskFromDate.setDate(today.getDate() - 12);
    this.defaultFromDate = taskFromDate.toISOString().split('T')[0];

    // Set the taskToDate to today's date
    let taskToDate = new Date(today);
    taskToDate.setDate(today.getDate() + 2);
    this.defaultToDate = taskToDate.toISOString().split('T')[0];

    this.taskFromDate = this.defaultFromDate;
    this.taskToDate = this.defaultToDate;

    this.onDateChangeDashboard(this.defaultFromDate, this.defaultToDate);

  }



  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;


    })
  }

  getEmployeeDetiailsBandLocation() {

    const request = {
      "companyId": this.loggedInUserCompanyID
    };
    this.httpService.callGetService(`${this.config.EmployeeDetiailsBandLocation}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      this.arrEmployeeDetiailsBandLocation = result.data;
    })
  }



  formatedataVariable = formatText;

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
  }

  getAllFinanceUserDD: any = []
  getAllUserDD() {

    this.httpService.callGetService(`${this.config.getAllEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {

        this.getAllFinanceUserDD = result.data.users;

      });
  }
  fitergetAllFinanceUserDD: any = [];
  getAllEmployeeListing() {

    // this.getAllEmployeeListinga()
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {

        this.tableDataDetails = [];
        this.allTeamMemberReimbursementApprove = [];
        this.allTeamReimbursement = [];
        this.fitergetAllFinanceUserDD = [];

        var tableDataDetails = response.data.filter(
          (data: { year: any; }) => data.year === this.selectedYearForCompetency
        );
        if (tableDataDetails.length == 0) {
          this.fitergetAllFinanceUserDD = [];
          this.arrBandsForReimursement = [];
          this.arrLocationForReimursement = [];
          this.arrExpensTypeData = [];
          this.allListingEmployeeIdForTeam = [];


          return;
        }
        const arrResultEmployeesData = this.arrEmployeeDetiailsBandLocation.filter((user: { id: any; }) => tableDataDetails.some((elm: { employeeId: { toString: () => any; }; }) => elm.employeeId.toString() === user.id));


        tableDataDetails.forEach((expense: any) => {
          const matchedUser = arrResultEmployeesData.find(
            (user: any) => +user.id === expense.employeeId
          );

          if (matchedUser) {
            expense['location'] = matchedUser.location;
            expense['band'] = matchedUser.band;

          }
        });

        tableDataDetails.map((elm: any) => {
          if (!this.arrBandsForReimursement.some((record: any) => record.band == elm.band)) {
            this.arrBandsForReimursement.push(elm);
          }

          if (!this.arrLocationForReimursement.some((record: any) => record.location == elm.location)) {
            this.arrLocationForReimursement.push(elm);
          }

        })

        this.arrBandsForReimursement = this.arrBandsForReimursement.filter((elm: any) => elm.band != null)
        this.arrLocationForReimursement = this.arrLocationForReimursement.filter((elm: any) => elm.band != null)



        if (tableDataDetails.length == 0) {
          return;
        }
        var allExpensData: { reimbursementid: any; reimbursementType: any; }[] = [];
        var arrEmployeesData: { employeeId: any; employeeName: any; }[] = [];
        const managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);

        if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
          // For Finance/Manager Login
          console.log("For Finance Login")
          // For Team Reimbursement Condition here --- finance

          // My Reimbursement -- current user login only show Reimbursement data (as employee)
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };

              // Check if employeeId already exists in the array (to avoid duplicates)
              let isDuplicateEmployee = this.allListingEmployeeId.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED") {
                if (!isDuplicateEmployee) {
                  elm.financeStatus = elm.approvedStatus;
                  this.allListingEmployeeId.push(arrEmployeeList); //TODO : main problem
                }
              }
              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {
                this.tableDataDetails.push(elm);
              }
              this.currentTableDataDetailsForEmployee = this.tableDataDetails;
            }
          });



          // For Team Reimbursement Condition here --- mnanager/finanace
          tableDataDetails.forEach((elm: any, i: any) => {

            if (elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              // Check if employeeId already exists in the array
              let isDuplicate = this.allListingEmployeeIdForTeam.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (!isDuplicate) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }

              if (elm.financeId == parseInt(this.loggedInUserId)) {
                let arrExpenseList = { "reimbursementid": elm.reimbursementid, "reimbursementType": elm.reimbursementType };
                allExpensData.push(arrExpenseList);
                this.arrExpensTypeData = this.removeDuplicateExpensIds(allExpensData);
              }

              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );

              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;

                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }
            }
          })
          // For Team Reimburesement
          this.currrentTableDataDetails = this.allTeamReimbursement;


          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );


            // Filter and update approved reimbursements
            if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_FINANCE') {
              if ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }
            } else {
              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }

            }
            elm.financeStatus = elm.approvedStatus; // status finance
            // console.log( elm.financeStatus);

            this.allTeamMemberReimbursementApprove.push(elm);



          });
          // Assign filtered approvals to currentallTeamMemberReimbursementApprove
          if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }
          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;


        } else if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
          // For Manager Login
          console.log("For Manager Login")
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };


              this.allListingEmployeeId.push(arrEmployeeList); // select employee

              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {

                if (elm.approvedByManager == null) {
                  elm.financeStatus = elm.approvedStatus;
                  elm.approvedStatus = 'PENDING';
                } else {
                  elm.approvedStatus = (elm.approvedStatus == 'Reject') ? elm.approvedStatus : elm.approvedByManager;

                }

                this.tableDataDetails.push(elm);
              }
              this.currentTableDataDetailsForEmployee = this.tableDataDetails;
            }
          })


          this.currrentTableDataDetails = this.tableDataDetails;
          // For Team Reimbursement Condition here --- mnanager
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId != elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }
              // this.allListingEmployeeIdForTeam.push(arrEmployeeList)
              // Check if employeeId already exists in the array before pushing
              if (!this.allListingEmployeeIdForTeam.find((employee: { employeeId: any; }) => employee.employeeId === elm.employeeId)) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }

              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );

              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;
                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }
            }
          })
          console.error(this.allListingEmployeeIdForTeam);

          this.currrentTableDataDetails = this.allTeamReimbursement;

        } else if (this.loggedInUserRole === 'Employee') {
          console.log("Employee Login")

          tableDataDetails?.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              console.log("Emp In ");

              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              const isDuplicate = this.allListingEmployeeId?.some(
                (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }

              // Avoid pushing duplicates into tableDataDetails

              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {

                this.tableDataDetails.push(elm);
              }
              this.currentTableDataDetailsForEmployee = this.tableDataDetails;
            }
          });

          this.currrentTableDataDetails = this.tableDataDetails;   // For Employee


          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );


            // Filter and update approved reimbursements
            if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
              if (!isDuplicate) {
                this.allListingEmployeeId.push(arrEmployeeList);
              }
            }


            if (elm.financeId == parseInt(this.loggedInUserId)) {
              let arrExpenseList = { "reimbursementid": elm.reimbursementid, "reimbursementType": elm.reimbursementType };
              allExpensData.push(arrExpenseList);
              this.arrExpensTypeData = this.removeDuplicateExpensIds(allExpensData);
            }

            if (elm.approvedStatus == 'PENDING') {
              elm.approvedStatus = 'PENDING';
            } else if (elm.approvedStatus == 'REJECTED') {
              elm.approvedStatus = elm.approvedStatus;
              elm.financeStatus = elm.approvedStatus;
            } else {
              elm.approvedStatus = 'APPROVED';
              elm.financeStatus = elm.approvedStatus;
            }

            this.allTeamMemberReimbursementApprove.push(elm);
          });



          // Assign filtered approvals to currentallTeamMemberReimbursementApprove
          if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }


          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;


        } else {
          console.log("Other Login")

          // allTeamMemberReimbursementApprove // for HR Admin

          tableDataDetails.forEach((elm: any, i: any) => {

            let arrExpenseList = { "reimbursementid": elm.reimbursementid, "reimbursementType": elm.reimbursementType };
            let arrEmployees = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };
            allExpensData.push(arrExpenseList);
            arrEmployeesData.push(arrEmployees);

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );
            // Filter for finance
            if (elm.approvedStatus == 'APPROVED' || elm.approvedStatus == 'REJECTED') {
              if (!isDuplicate) {
                this.fitergetAllFinanceUserDDHrAdmin.push(elm.financeId)
              }
            }
          })

          this.arrExpensTypeData = this.removeDuplicateExpensIds(allExpensData);


          const matchingUsers = this.getAllFinanceUserDD.filter((user: any) => this.fitergetAllFinanceUserDDHrAdmin.includes(user.id));


          this.fitergetAllFinanceUserDD = matchingUsers;

          this.allTeamMemberReimbursementApprove = tableDataDetails.filter(
            (data: { year: any; }) => data.year === this.selectedYearForCompetency
          );

          this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;

        }

      });
  }

  removeDuplicateExpensIds(data: any[]) {
    const seen = new Set();
    return data.filter((item) => {
      if (seen.has(item.reimbursementid)) {
        return false;
      }
      seen.add(item.reimbursementid);
      return true;
    });
  }

  getEmployeeForReimbursement(event: any): void {

    if (event == '-1') {
      this.allTeamReimbursement = this.currrentTableDataDetails;
    } else {
      // Use the original array to filter and update `tableDataDetails`.
      const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

        return elm.employeeId === event;
      });

      // If matches are found, update the array with the new one.
      if (updatedTableDataDetails.length > 0) {

        this.allTeamReimbursement = updatedTableDataDetails;
      }

    }
  }

  // Select All Band
  getBandForReimbursement(event: any) {
    if (event == '-1') {

      this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      this.allListingEmployeeId = [];
      this.selectedEmployee = -1;
    } else {
      const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.band == event);
      this.selectedEmployee = -1;


      this.allListingEmployeeId = data;

      // Use the original array to filter and update `tableDataDetails`.
      const updatedTableDataDetails = data.filter((elm: any) => elm.band === event);
      console.log(updatedTableDataDetails);

      this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
    }




  }

  //Select All Location
  getLocationForReimbursement(event: any) {
    if (event == '-1') {

      this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      this.allListingEmployeeId = [];
      this.selectedEmployee = -1;
    } else {
      const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.location == event);
      this.selectedEmployee = -1;


      this.allListingEmployeeId = data;

      // Use the original array to filter and update `tableDataDetails`.
      const updatedTableDataDetails = data.filter((elm: any) => elm.location === event);
      console.log(updatedTableDataDetails);

      this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
    }
  }


  // For Select Expense Type
  getExpensTypeForReimbursement(event: any) {

    if (event == '-1') {
      console.error(this.currentallTeamMemberReimbursementApprove);

      this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      this.allListingEmployeeId = [];
      this.selectedEmployee = -1;
    } else {
      console.error(event);

      const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.reimbursementid == event);
      this.selectedEmployee = -1;


      this.allListingEmployeeId = data;

      // Use the original array to filter and update `tableDataDetails`.
      const updatedTableDataDetails = data.filter((elm: any) => elm.reimbursementid === event);
      this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
    }


    //check user list by finance admin


  }







  financeIdForEmployee: number = -1; // Default value

  getEmployeeForReimbursementApprove(event: any): void {

    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {

          this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
        }

      }
    } else {



      if (event == '-1') {


        this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
        // this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm:any)=>elm.financeId==this.financeIdForEmployee);
      } else {
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => (elm.financeId == this.financeIdForEmployee && elm.employeeId == event));

        this.allTeamMemberReimbursementApprove = data;
      }
    }
  }

  // For Year Select
  viewReimbursementReportByYear(year: any) {
    this.selectedYearForCompetency = year;
    this.getAllEmployeeListing();
  }

  selectedEmployee: any = -1;

  // For Select Finance 
  getFinaceForReimbursement(event: any) {
    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.isShowSelectEmployee = false;
        this.tableDataDetails = this.currrentTableDataDetails;
        // this.allListingEmployeeId = [];
        // this.selectedEmployee = -1;
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {
          this.isShowSelectEmployee = true;
          this.tableDataDetails = updatedTableDataDetails;
        }

      }
    } else {
      if (event == '-1') {
        this.isShowSelectEmployee = false;
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
        this.allListingEmployeeId = [];
        this.selectedEmployee = -1;
      } else {
        this.isShowSelectEmployee = true;
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.financeId == event);
        this.selectedEmployee = -1;

        const uniqueData = data.filter((item: any, index: any, self: any) =>
          index === self.findIndex((t: any) => t.employeeId === item.employeeId)
        );


        this.allListingEmployeeId = uniqueData;

        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.financeId === event);
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }

    }

    //check user list by finance admin


  }
  taskColumnHeaderInfo: any[] = [];

  taskColumnHeaderInfoForManager: any[] = [];
  taskColumnHeaderInfoForFinanse: any = [];
  empReimbursementTable() {


    const commonColumns = [
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'date' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'assignedAmount' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'uploadDocument' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: true, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: true, sortingName: 'financeComment' },
      { label: 'Approved Status', isMandatory: true, sortingName: 'approvedStatus' },

    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: true, sortingName: 'managerComment' };
      const employeeCommentIndex = commonColumns.findIndex(column => column.sortingName === 'employeeComment');
      commonColumns.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }

    this.taskColumnHeaderInfo = commonColumns;

    const taskColumnHeaderInfoForManager = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'startDate' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      // { label: 'Reimbursement Id', isMandatory: true, sortingName: 'reimbursementId' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'assignedAmount' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'uploadDocument' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: true, sortingName: 'employeeComment' },

      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvedStatus' },

    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForManager.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForManager.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }

    this.taskColumnHeaderInfoForManager = taskColumnHeaderInfoForManager;


    const taskColumnHeaderInfoForFinanse = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement Type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Location', isMandatory: true, sortingName: 'location' },
      { label: 'Band', isMandatory: true, sortingName: 'band' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'startDate' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      // { label: 'Reimbursement Id', isMandatory: true, sortingName: 'reimbursementId' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: ' assignedAmount' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'uploadDocument' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvedStatus' },

    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {

      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanse.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForFinanse.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }



    const taskColumnHeaderInfoForFinanceHRAdmin = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement Type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Location', isMandatory: true, sortingName: 'location' },
      { label: 'Band', isMandatory: true, sortingName: 'band' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'date' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      // { label: 'Reimbursement Id', isMandatory: true, sortingName: 'reimbursementId' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'assignedAmount' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'uploadDocument' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvedStatus' }
    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForFinanceHRAdmin.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    this.taskColumnHeaderInfoForFinanse = (this.loggedInUserRole == 'HR Admin') ? taskColumnHeaderInfoForFinanceHRAdmin : taskColumnHeaderInfoForFinanse;

  }



  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }
  onSortAssending(sortKey: any): void {
    console.log("onSortAssending" + sortKey);

    if (this.loggedInUserRole == 'Employee') {
      this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
        if (a[sortKey] < b[sortKey]) return -1;
        if (a[sortKey] > b[sortKey]) return 1;
        return 0;
      });
    } else if (this.loggedInUserRole == 'Manager') {
      if (this.selectedTypeTabName == 'Employee') {
        this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
          if (a[sortKey] < b[sortKey]) return -1;
          if (a[sortKey] > b[sortKey]) return 1;
          return 0;
        });
      } else if (this.selectedTypeTabName == 'Finance') {
        this.allTeamMemberReimbursementApprove.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
          if (a[sortKey] < b[sortKey]) return -1;
          if (a[sortKey] > b[sortKey]) return 1;
          return 0;
        });
      } else {
        this.allTeamReimbursement.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
          if (a[sortKey] < b[sortKey]) return -1;
          if (a[sortKey] > b[sortKey]) return 1;
          return 0;
        });

      }
    } else if (this.loggedInUserRole == 'HR Admin') {

      this.allTeamMemberReimbursementApprove.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
        if (a[sortKey] < b[sortKey]) return -1;
        if (a[sortKey] > b[sortKey]) return 1;
        return 0;
      });
    }
  }
  onSortDesending(sortKey: any): void {
    console.log("onSortDesending");

    if (this.loggedInUserRole == 'Employee') {

      this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
        if (a[sortKey] > b[sortKey]) return -1;
        if (a[sortKey] < b[sortKey]) return 1;
        return 0;
      });
    } else if (this.loggedInUserRole == 'Manager') {
      if (this.selectedTypeTabName == 'Employee') {
        this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
          if (a[sortKey] > b[sortKey]) return -1;
          if (a[sortKey] < b[sortKey]) return 1;
          return 0;
        });
      } else if (this.selectedTypeTabName == 'Finance') {
        this.allTeamMemberReimbursementApprove.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
          if (a[sortKey] > b[sortKey]) return -1;
          if (a[sortKey] < b[sortKey]) return 1;
          return 0;
        });
      } else {
        this.allTeamReimbursement.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
          if (a[sortKey] > b[sortKey]) return -1;
          if (a[sortKey] < b[sortKey]) return 1;
          return 0;
        });

      }
    } else if (this.loggedInUserRole == 'HR Admin' || sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
      this.allTeamMemberReimbursementApprove.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
        if (a[sortKey] > b[sortKey]) return -1;
        if (a[sortKey] < b[sortKey]) return 1;
        return 0;
      });
    }
  }

  // Function to filter data according to the selected page size
  onPageSizeChange(): void {
    console.log("onPageSizeChange");
    console.log(this.financePerson + "-" + this.loggedInUserId + " " + this.loggedInUserRole);

    if (this.loggedInUserRole == 'Employee') {
      this.tableDataDetails = this.currrentTableDataDetails.slice(0, this.selectedPageSize);
      this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.slice(0, this.selectedPageSize);

    } else if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && this.financePerson == this.loggedInUserId) {

      if (this.selectedTypeTabName == 'Manager') {
        this.allTeamReimbursement = this.currrentTableDataDetails.slice(0, this.selectedPageSize);

      } else if (this.selectedTypeTabName == 'Employee') {
        this.tableDataDetails = this.currentTableDataDetailsForEmployee.slice(0, this.selectedPageSize);

      } else if (this.selectedTypeTabName == 'Finance') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.slice(0, this.selectedPageSize);

      }


    } else if (this.loggedInUserRole == 'HR Admin') {
      this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.slice(0, this.selectedPageSize);

    }
  }
  downloadExcel(): void {
    // Helper function to map data for Excel generation
    const mapReimbursementData = (rows: any[]): any[] => {
      const result: any[] = [];

      rows.forEach((row: any) => {
        // Define the common fields

        var approvedStatus = (this.selectedTypeTabName == 'Manager') ? (row.approvedByManager || 'PENDING') : (this.selectedTypeTabName == 'Finance') ? row.approvedStatus : ((row.approvedStatus == 'APPROVED') || (row.approvedStatus == 'REJECTED')) ? row.approvedStatus : (row.approvedByManager || 'PENDING');

        const mappedRow: any = {
          'Reimbursement Type': row.reimbursementType,
          'Start Date': formatDate(row.date), // Custom date format 'dd-mm-yyyy'
          'Limit of Reimbursement': row.reimbursementLimit,
          'Actual Amount': row.actualAmount,
          'Actual amount by finance': row.assignedAmount,
          'Attach Document Proof': row.uploadDocument,
          'Status': formatText(row.status), // Optional formatting for Status
          'Employee Comment': row.employeeComment,
          'Manager Comment': row.managerComment,
          'Finance Comment': row.financeComment,
          'Approved Status': approvedStatus
        };

        // Conditionally add 'Employee Name' at index 0
        if (this.selectedTypeTabName !== 'Employee') {
          const reorderedRow: any = { 'Employee Name': row.employeeName || '', ...mappedRow }; // 'Employee Name' at index 0
          result.push(reorderedRow);
        } else {
          result.push(mappedRow);
        }
      });

      return result;
    };

    // Determine the data source based on the logged-in user role and selected tab
    let data: any[] = [];

    switch (this.loggedInUserRole) {
      case 'Employee':
        data = this.selectedTypeTabName === 'Employee'
          ? mapReimbursementData(this.tableDataDetails)
          : mapReimbursementData(this.allTeamMemberReimbursementApprove);
        break;

      case 'Manager':
        if (this.selectedTypeTabName === 'Employee') {
          data = mapReimbursementData(this.tableDataDetails);
        } else if (this.selectedTypeTabName === 'Finance') {
          data = mapReimbursementData(this.allTeamMemberReimbursementApprove);
        } else {
          data = mapReimbursementData(this.allTeamReimbursement);
        }
        break;

      case 'HR Admin':
        data = mapReimbursementData(this.allTeamMemberReimbursementApprove);
        break;

      default:
        console.warn('Unknown user role:', this.loggedInUserRole);
        return;
    }

    // Generate and download the Excel file
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reimbursements');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'Reimbursements');
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Format as dd-mm-yyyy
    if (this.loggedInUserRole == 'Employee') {
      if (this.selectedTypeTabName == 'Employee') {
        saveAs(data, `${fileName}-My-${fileName}-${formattedDate}.xlsx`);
      } else {


        saveAs(data, `${fileName}-${this.loggedInUserCompanyName}-${fileName}-${formattedDate}.xlsx`);
      }
    } else if (this.loggedInUserRole == 'Manager') {
      if (this.selectedTypeTabName == 'Employee') {

        saveAs(data, `${fileName}-My-${fileName}-${formattedDate}.xlsx`);
      } else if (this.selectedTypeTabName == 'Finance') {
        saveAs(data, `${fileName}-${this.loggedInUserCompanyName}-${fileName}-${formattedDate}.xlsx`);

      } else {
        saveAs(data, `${fileName}-Team-${fileName}-${formattedDate}.xlsx`);

      }
    } else if (this.loggedInUserRole == 'HR Admin') {
      saveAs(data, `${fileName}-My-${fileName}-${formattedDate}.xlsx`);
    }
  }
  taskFromDate: Date | null = null;
  taskToDate: Date | null = null;
  filteredData: any[] = []; // Holds the filtered data

  onDateChangeDashboard(defaultFromDate?: any, defaultToDate?: any): void {
    console.log("onDateChangeDashboard Report")
    this.taskFromDate = defaultFromDate;
    this.taskToDate = defaultToDate;
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      // Ensure both dates are set to midnight in their respective local time zones
      fromDate.setHours(0, 0, 0, 0);  // Start of the day in local time
      toDate.setHours(23, 59, 59, 999); // End of the day in local time

      // Function to format dates to the desired ISO format with UTC (+00:00)
      const toISOWithUTCOffset = (date: Date): string => {
        const pad = (num: number): string => String(num).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are zero-based
        const day = pad(date.getDate());

        return `${year}-${month}-${day}T00:00:00.000+00:00`;
      };

      // Format both dates to the start and end of the day in local time
      const formattedFromDate = toISOWithUTCOffset(fromDate);
      const formattedToDate = toISOWithUTCOffset(toDate);


      if (this.loggedInUserRole == 'Employee') {
        console.log(" Only Employee");
        // Proceed with filtering the data
        const filteredData = this.currrentTableDataDetails.filter((item: any) => {
          const itemDate = new Date(item.date); // Parse item.date to Date object
          return (
            itemDate >= new Date(formattedFromDate) &&
            itemDate <= new Date(formattedToDate)
          );
        });


        // Update the table data for rendering
        this.tableDataDetails = filteredData;


        const filteredDataForFinance = this.currentallTeamMemberReimbursementApprove.filter((item: any) => {
          // Filtering condition
          const itemDate = item.date; // Parse item.date to Date object
          return (
            itemDate >= formattedFromDate &&
            itemDate <= formattedToDate
          );


        });

        this.allTeamMemberReimbursementApprove = filteredDataForFinance;

      } else if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) {

        if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && this.financePerson == this.loggedInUserId) {
          console.log("Manager And Finance");
          if (this.selectedTypeTabName == 'Employee') {
            const filteredData = this.currentTableDataDetailsForEmployee.filter((item: any) => {
              const itemDate = new Date(item.date); // Parse item.date to Date object
              return (
                itemDate >= new Date(formattedFromDate) &&
                itemDate <= new Date(formattedToDate)
              );
            });
            this.tableDataDetails = filteredData;
          } else if (this.selectedTypeTabName == 'Finance') {
            const filteredData = this.currentallTeamMemberReimbursementApprove.filter((item: any) => {
              const itemDate = new Date(item.date); // Parse item.date to Date object
              return (
                itemDate >= new Date(formattedFromDate) &&
                itemDate <= new Date(formattedToDate)
              );
            });
            this.allTeamMemberReimbursementApprove = filteredData;
          } else {
            const filteredData = this.currrentTableDataDetails.filter((item: any) => {
              const itemDate = new Date(item.date); // Parse item.date to Date object
              return (
                itemDate >= new Date(formattedFromDate) &&
                itemDate <= new Date(formattedToDate)
              );
            });
            this.allTeamReimbursement = filteredData;

          }
        } else {
          console.log(" Only Manager");
          const filteredData = this.allTeamReimbursement.filter((item: any) => {
            const itemDate = new Date(item.date); // Parse item.date to Date object
            return (
              itemDate >= new Date(formattedFromDate) &&
              itemDate <= new Date(formattedToDate)
            );
          });
          this.allTeamReimbursement = filteredData;

        }
      }
      else if (this.loggedInUserRole == 'HR Admin') {

        const filteredData = this.currentallTeamMemberReimbursementApprove.filter((item: any) => {
          // Filtering condition
          const itemDate = item.date; // Parse item.date to Date object
          return (
            itemDate >= formattedFromDate &&
            itemDate <= formattedToDate
          );


        });

        this.allTeamMemberReimbursementApprove = filteredData;
      }
    } else {
      console.log('No filtering applied, returning all data');
    }
  }
  pmsYears: any = []
  selectedYearForCompetency: any = null;
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`;
  //       } else {
  //         yearValue = `${currentYear}-${currentYear + 1}`;
  //       }

  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;


  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });

  //     this.getAllEmployeeListing();

  //     // Call additional functions if needed
  //     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
  //       || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
  //       // Add your logic here
  //     }

  //   });

  // }



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);

      this.getAllEmployeeListing();

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }







  searchTaskString: string = '';

  onSearchTask(searchString: string) {

    console.log("onSearchTask --" + this.loggedInUserRole);

    if (this.loggedInUserRole == 'Employee') {


      let seacrhData = this.tableDataDetails;
      if (searchString == '') {

        this.getAllEmployeeListing();
        this.tableDataDetails = [...this.tableDataDetails]; // Update tableDataDetails with full data
      } else {
        // Filter rows based on the search string matching any of the fields
        this.filteredData = seacrhData.filter((row: any) =>
          (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
          (row.actualAmount && row.actualAmount.toString().includes(searchString))
          ||
          (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
          ||
          (row.status && row.status.toString().includes(searchString))
          ||
          (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
        );

        this.tableDataDetails = [...this.filteredData];

      }
    } else if (this.loggedInUserRole == 'Manager') {

      if (this.selectedTypeTabName == 'Employee') {
        let seacrhDataForTeam = this.currentTableDataDetailsForEmployee;
        if (searchString == '') {

          this.getAllEmployeeListing();
          this.tableDataDetails = [...this.currentTableDataDetailsForEmployee]; // Update tableDataDetails with full data
        } else {
          // Filter rows based on the search string matching any of the fields
          this.filteredData = seacrhDataForTeam.filter((row: any) =>
            (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
            (row.actualAmount && row.actualAmount.toString().includes(searchString))
            ||
            (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
            ||
            (row.status && row.status.toString().includes(searchString))
            ||
            (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
          );

          this.tableDataDetails = [...this.filteredData];

        }

      } else if (this.selectedTypeTabName == 'Finance') {

        let seacrhDataForTeam = this.currentallTeamMemberReimbursementApprove;
        if (searchString == '') {

          this.getAllEmployeeListing();
          this.allTeamMemberReimbursementApprove = [...this.currentallTeamMemberReimbursementApprove]; // Update tableDataDetails with full data
        } else {
          // Filter rows based on the search string matching any of the fields
          this.filteredData = seacrhDataForTeam.filter((row: any) =>
            (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
            (row.actualAmount && row.actualAmount.toString().includes(searchString))
            ||
            (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
            ||
            (row.status && row.status.toString().includes(searchString))
            ||
            (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
          );

          this.allTeamMemberReimbursementApprove = [...this.filteredData];

        }

      } else {

        let seacrhDataForTeam = this.allTeamReimbursement;
        if (searchString == '') {

          this.getAllEmployeeListing();
          this.allTeamReimbursement = [...this.allTeamReimbursement]; // Update tableDataDetails with full data
        } else {
          // Filter rows based on the search string matching any of the fields
          this.filteredData = seacrhDataForTeam.filter((row: any) =>
            (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
            (row.actualAmount && row.actualAmount.toString().includes(searchString))
            ||
            (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
            ||
            (row.status && row.status.toString().includes(searchString))
            ||
            (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
          );

          this.allTeamReimbursement = [...this.filteredData];

        }
      }


    } else if (this.loggedInUserRole == 'HR Admin') {
      let seacrhDataForTeam = this.allTeamMemberReimbursementApprove;
      if (searchString == '') {

        this.getAllEmployeeListing();
        this.allTeamMemberReimbursementApprove = [...this.allTeamMemberReimbursementApprove]; // Update tableDataDetails with full data
      } else {
        // Filter rows based on the search string matching any of the fields
        this.filteredData = seacrhDataForTeam.filter((row: any) =>


          (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
          (row.actualAmount && row.actualAmount.toString().includes(searchString))
          ||
          (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
          ||
          (row.status && row.status.toString().includes(searchString))
          ||
          (row.approvedStatus && row.approvedStatus.toLowerCase().includes(searchString))
        );

        this.allTeamMemberReimbursementApprove = [...this.filteredData];

      }
    }



  }



} 
